// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UDpX","rootNoMargin":"styles_rootNoMargin__1b-Da"};